import _regenerator from "/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { mapGetters } from "vuex";
import { isEmpty, isMobile } from '@/commons/utils/functions';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { getDocsSign, createValidationNaat, saveValidationNaat, getCredencialesNaat, saveFaceNaat } from "@/routes/api/views/vales";
import PzButton from "@/commons/forms/Buttons/PzButton";
import { Objeto } from "@/commons/forms/DigitalSings/Fad/EventoNaat";
import { CONFIGURATIONACUANT, CONFIGURATIONFace } from "@/commons/forms/DigitalSings/Fad2/Configuracion";
import FadSDK from '@/commons/forms/DigitalSings/Fad2/fad-sdk.min.nuevo.js';
export default {
  name: "PzFadSdk",
  components: {
    VueQrcode: VueQrcode,
    PzButton: PzButton
  },
  props: {
    route: {
      require: true,
      default: null,
      type: [String, URL]
    },
    redirect: {
      require: true,
      default: 'Prestamos',
      type: [String]
    }
  },
  data: function data() {
    return {
      frame_route: this.route,
      cambioTexto: "",
      tipo: 1,
      entorno: '',
      intentos: 1,
      side: 0,
      imageId: '',
      imageFace: '',
      ocr: '',
      url: window.location.href,
      height: '600px',
      watch: {
        route: function route(value) {
          this.frame_route = value;
        },
        frame_route: function frame_route(value) {
          console.log('change form route');
          console.log(value);
        }
      },
      continuar: false,
      moduleParams: {
        credentials: '',
        configuration: CONFIGURATIONACUANT,
        side: 0,
        // 0 - front id, 1 - back id
        idData: false,
        // true - ocr, false - without this data
        idPhoto: false,
        // true - get imaghen face of id, false - without this data
        imageQuality: 0.5 // quality of image id, range 0 - 1
      },
      CREDENTIALSAcuant: '',
      CREDENTIALSFace: '',
      sharpnessThreshold: '55',
      middleware: false,
      FAD_SDK: '',
      TOKEN: '',
      ENTORNO: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['alias'])), {}, {
    esmobil: function esmobil() {
      return isMobile();
    }
  }),
  created: function created() {
    this.getCredenciales();
  },
  methods: {
    eventos: function eventos(event) {
      if (event.data) switch (event.data.event) {
        case 'PROCESS_ERROR':
          console.log('PROCESS_ERROR');
          console.log(event.data);
          break;
        case 'PROCESS_COMPLETED':
          console.log("Process completed");
          var result = event.data.data;
          if (this.tipo == 1) {
            this.crearValidacion({
              'imageFront': result.id.front.image.data,
              'imageBack': result.id.back.image.data,
              'ocr': result.idData.ocr,
              'foto': result.idPhoto,
              'alerts': result.idData.alerts
            });
          } else if (this.tipo == 2) {
            this.saveFace({
              'imgLowQuality': result.lowQualityAuditTrail[0]
            });
          } else {
            this.continuar = true;
            this.loading = false;
            this.handleSend();
          }
          break;
        case 'PROCESS_ENDED':
          if (this.tipo == 3) {
            this.continuar = true;
            this.loading = false;
            this.handleSend();
            console.log('proceso terminado firma');
          }
          break;
        case 'SIGNATURE_COMPLETED':
          if (this.tipo == 3) {
            this.continuar = true;
            this.loading = false;
            this.handleSend();
            console.log('proceso de firma completo');
          }
          break;
        default:
          return;
      }
    },
    iniciarFAD: function iniciarFAD() {
      var options = {
        environment: FadSDK.getFadEnvironments()[this.ENTORNO]
      };
      console.log('iniciarFAD');
      console.log(options);
      console.log(FadSDK.getFadEnvironments().UAT);
      console.log(FadSDK.getFadEnvironments().PROD);
      var TOKEN = this.TOKEN;
      this.FAD_SDK = new FadSDK(TOKEN, options);
    },
    getCredenciales: function getCredenciales() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.$store.dispatch('loader/up', {
                trigger: _this.$options.name
              });
              _context.n = 1;
              return getCredencialesNaat().then(function (res) {
                _this.CREDENTIALSAcuant = res.data.CREDENTIALSAcuant;
                _this.CREDENTIALSFace = res.data.CREDENTIALSFace;
                _this.moduleParams.credentials = res.data.CREDENTIALSAcuant;
                _this.sharpnessThreshold = res.data.sharpnessThreshold;
                _this.moduleParams.configuration.sharpnessThreshold = _this.sharpnessThreshold;
                _this.middleware = res.data.middleware;
                _this.TOKEN = res.data.token;
                _this.ENTORNO = res.data.tipo;
                _this.iniciarFAD();
                window.addEventListener("message", _this.eventos, false);
                _this.intentos = 1;
                _this.initProcess();
              }).catch(function (error) {
                _this.$store.dispatch('app/catchErrors', {
                  _this: _this,
                  error: error
                });
              }).finally(function () {
                _this.$store.dispatch('loader/down', {
                  trigger: _this.$options.name
                });
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    initIframe: function initIframe() {
      var iframe = document.getElementById("naat");
      iframe.src = this.frame_route;
    },
    handleSend: function handleSend() {
      this.$store.dispatch('loader/up', {
        trigger: this.$options.name
      });
      this.$router.push({
        name: 'FinFirma',
        params: {
          cambiotexto: this.cambioTexto
        }
      });
      this.$store.dispatch('loader/down', {
        trigger: this.$options.name
      });
    },
    handleError: function handleError() {
      if (this.intentos < 3) {
        this.iniciarFAD();
        this.$store.dispatch('app/setMessage', 'Nuevo intento para la captura de información');
        this.intentos = this.intentos + 1;
        if (this.tipo == 1) this.initProcess();else if (this.tipo == 2) this.initModuleFacetec();else this.initModuleFirma();
      } else {
        this.handleRechazo();
      }
    },
    handleRechazo: function handleRechazo() {
      var comp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      console.log('handleRechazo');
      this.FAD_SDK.end();
      var motivo = '';
      if (this.tipo == 1) motivo = this.$t('motivo_rechazo.acuant');else if (this.tipo == 2) motivo = this.$t('motivo_rechazo.facetec');else motivo = this.$t('motivo_rechazo.firma');
      this.tipo = 1;
      this.intentos = 1;
      this.side = 0;
      //   window.removeEventListener("message", this.eventos, false);
      this.$store.dispatch('loader/up', {
        trigger: this.$options.name
      });
      this.$router.push({
        name: 'FadRechazo',
        params: {
          mensaje: motivo
        }
      });
      this.$store.dispatch('loader/down', {
        trigger: this.$options.name
      });
    },
    initModule: function initModule() {
      var iframe = document.getElementById("naat");
      console.log(this.moduleParams);
      iframe.contentWindow.postMessage(Objeto("INIT_MODULE", this.moduleParams), iframe.src);
    },
    initProcess: function initProcess() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var idData, idPhoto, acuantResponse, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              idData = true; // true - ocr, false - without this data
              idPhoto = true; // true - get imaghen face of id, false - without this data
              // Returns the image of identification (id.image.data) and relevant information (sharpness, glare), documentInstance, idData and idPhoto
              console.log('initProcess');
              console.log(_this2.CREDENTIALSAcuant);
              console.log(idData);
              console.log(idPhoto);
              console.log(CONFIGURATIONACUANT);
              _context2.n = 1;
              return _this2.FAD_SDK.startAcuant(_this2.CREDENTIALSAcuant, idData, idPhoto, CONFIGURATIONACUANT);
            case 1:
              acuantResponse = _context2.v;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.log('error acuant');
              console.log(_t);
              _this2.FAD_SDK.end();
              _this2.handleError();
            case 3:
              _context2.p = 3;
              console.log('finally sdk acuant');
              return _context2.f(3);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2, 3, 4]]);
      }))();
    },
    initModuleFacetec: function initModuleFacetec() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var CREDENTIALS, facetecResponse, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              console.log('initModuleFacetec ');
              CREDENTIALS = _this3.CREDENTIALSFace;
              _context3.p = 1;
              _context3.n = 2;
              return _this3.FAD_SDK.startFacetec(null, CONFIGURATIONFace, CREDENTIALS);
            case 2:
              facetecResponse = _context3.v;
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              console.log('error face');
              console.log(_t2);
              _this3.FAD_SDK.end();
              _this3.handleError();
            case 4:
              _context3.p = 4;
              console.log('finally sdk face');
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, null, [[1, 3, 4, 5]]);
      }))();
    },
    initModuleFirma: function initModuleFirma() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var ticket, facetecResponse, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              console.log('initModuleFirma ');
              _this4.getRoute(3);
              _this4.tipo = 3;

              // const iframe = document.getElementById("naat");
              ticket = _this4.frame_route;
              _context4.p = 1;
              _context4.n = 2;
              return _this4.FAD_SDK.startFadWeb4(ticket);
            case 2:
              facetecResponse = _context4.v;
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              console.log('error firma');
              console.log(_t3);
              _this4.FAD_SDK.end();
              _this4.handleError();
            case 4:
              _context4.p = 4;
              console.log('finally sdk firma');
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 3, 4, 5]]);
      }))();
    },
    getRoute: function getRoute() {
      var _arguments = arguments,
        _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var tipo;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              tipo = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 2;
              _this5.$store.dispatch('loader/up', {
                trigger: _this5.$options.name
              });
              _context5.n = 1;
              return getDocsSign({
                'loan': _this5.$route.params.loan,
                'tipo': tipo
              }).then(function (res) {
                if (res.data.valid && !isEmpty(res.data.ruta)) {
                  _this5.frame_route = res.data.ruta;
                  _this5.cambioTexto = res.data.formulario;
                }
              }).catch(function (error) {
                console.log('error ruta');
                console.log(error);
                _this5.$store.dispatch('app/catchErrors', {
                  _this: _this5,
                  error: error
                });
              }).finally(function () {
                _this5.$store.dispatch('loader/down', {
                  trigger: _this5.$options.name
                });
              });
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    crearValidacion: function crearValidacion(result) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              console.log('crearValidacion');
              console.log(_this6.$route.params);
              _this6.$store.dispatch('loader/up', {
                trigger: _this6.$options.name
              });
              _context6.n = 1;
              return createValidationNaat(_this6.$route.params.loan, result).then(function (res) {
                if (!res.data.valid) {
                  _this6.$store.dispatch('app/catchErrors', {
                    _this: _this6,
                    error: 'Problemas registro naat '
                  });
                } else {
                  _this6.saveValidation();
                }
              }).catch(function (error) {
                console.log('error ruta');
                console.log(error);
                _this6.$store.dispatch('app/catchErrors', {
                  _this: _this6,
                  error: error
                });
              }).finally(function () {
                _this6.$store.dispatch('loader/down', {
                  trigger: _this6.$options.name
                });
              });
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    saveValidation: function saveValidation() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              console.log('saveValidationNaat');
              _this7.$store.dispatch('loader/up', {
                trigger: _this7.$options.name
              });
              _context7.n = 1;
              return saveValidationNaat(_this7.$route.params.loan).then(function (res) {
                if (!res.data.valid) {
                  _this7.handleRechazo(1);
                } else {
                  _this7.getRoute();
                  _this7.tipo = 2;
                  _this7.intentos = 1;
                  _this7.initModuleFacetec();
                }
              }).catch(function (error) {
                console.log('error ruta');
                console.log(error);
                _this7.$store.dispatch('app/catchErrors', {
                  _this: _this7,
                  error: error
                });
              }).finally(function () {
                _this7.$store.dispatch('loader/down', {
                  trigger: _this7.$options.name
                });
              });
            case 1:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    saveFace: function saveFace(result) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              console.log('saveFace');
              _this8.$store.dispatch('loader/up', {
                trigger: _this8.$options.name
              });
              _context8.n = 1;
              return saveFaceNaat(_this8.$route.params.loan, result).then(function (res) {
                if (!res.data.valid) {
                  _this8.handleRechazo(1);
                } else {
                  _this8.initModuleFirma();
                }
              }).catch(function (error) {
                console.log('error saveFace');
                console.log(error);
                _this8.$store.dispatch('app/catchErrors', {
                  _this: _this8,
                  error: error
                });
              }).finally(function () {
                _this8.$store.dispatch('loader/down', {
                  trigger: _this8.$options.name
                });
              });
            case 1:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    }
  }
};